<template>
<div>
   <Breadcrumb> 
            <span><router-link :to="{ path:'/'}">Početna</router-link></span>
            <span class="separetor">/</span>
            <span class="font-weight-bolder"><router-link :to="{ path:'/marketing'}">Marketing</router-link></span>
     </Breadcrumb>
    <section class="has-sidebar u-padding-tb-40">
            <div class="container">
                <div class="row" data-sticky_parent>
                    <div class="col-lg-12 content-wrapper">
                        <div data-sticky_column>
                            <div class="contact-form">
                                <div class="form-title">
                                    <h4>Marketing</h4>
                                </div>
                                <div class="form-body">
                                    <div class="m-post-content">
                                      <div class="entry-content">
                                        {{ marketingInfo.text }}
                                       <div v-if="marketingInfo.absolutePhotoUrl" class="marketing-photo u-margin-t-20">
                                            <img v-lazy="marketingInfo.absolutePhotoUrl" alt="Marketing Photo">
                                        </div> 
                                        <br/><br/>
                                        <h3>Desktop formati</h3>
                                       <table class="table">
                                          <thead>
                                              <tr>
                                                  <th>Banner</th>
                                                  <th>Dimenzije (px)</th>
                                                  <th>Pozicija</th>
                                                  <th>Format</th>
                                                  <th>Cijena (CPM)*</th>
                                              </tr>
                                          </thead>
                                          <tbody>
                                              <tr>
                                                  <td>Premium Billboard</td>
                                                  <td>Desktop - 970x250 px</td>
                                                  <td>Na naslovnici</td>
                                                  <td>jpeg, gif, png, html5</td>
                                                  <td>15</td>
                                              </tr>
                                              <tr>
                                                  <td>Leaderboard</td>
                                                  <td>Desktop – 970x100 px</td>
                                                  <td>Na naslovnici</td>
                                                  <td>jpeg, gif, png, html5</td>
                                                  <td>10</td>
                                              </tr>
                                              <tr>
                                                  <td>Half Page</td>
                                                  <td>Desktop – 300x600 px</td>
                                                  <td>Na naslovnici</td>
                                                  <td>jpeg, gif, png, html5</td>
                                                  <td>15</td>
                                              </tr>
                                              <tr>
                                                  <td>Rectangle</td>
                                                  <td>Desktop – 300x250 px</td>
                                                  <td>U tekstu</td>
                                                  <td>jpeg, gif, png, html5</td>
                                                  <td>10</td>
                                              </tr>
                                              <tr>
                                                  <td>Skyscarper</td>
                                                  <td>Desktop – 160x600 px</td>
                                                  <td>Na naslovnici</td>
                                                  <td>jpeg, gif, png, html5</td>
                                                  <td>14</td>
                                              </tr>
                                          </tbody>
                                       </table>
                                        <small>* CPM – cijena na 1.000 prikazivanja</small>

                                        <div class="row u-margin-t-20 u-margin-b-40">
                                            <div class="col-md">
                                                <div class="card">
                                                    <div class="card-body">
                                                        <h5 class="card-title">Premium Billboard</h5>
                                                        <p class="card-text"><img src="/src/assets/img/marketing/premium_bilboard.jpg" width="100"></p>
                                                    </div>
                                                    </div>
                                                </div>
                                            <div class="col-md">
                                                <div class="card">
                                                    <div class="card-body">
                                                    <h5 class="card-title"> Leaderboard </h5>
                                                    <p class="card-text"><img src="/src/assets/img/marketing/leaderboard.jpg" width="100"></p>
                                                </div>
                                                </div>
                                            </div>
                                            <div class="col-md">
                                                <div class="card">
                                                    <div class="card-body">
                                                        <h5 class="card-title"> Half-Page</h5>
                                                        <p class="card-text"><img src="/src/assets/img/marketing/halfpage.jpg" width="100"></p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md">
                                                <div class="card">
                                                    <div class="card-body">
                                                        <h5 class="card-title"> Rectangle</h5>
                                                        <p class="card-text"><img src="/src/assets/img/marketing/rectangle.jpg" width="100"></p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md">
                                                <div class="card">
                                                <div class="card-body">
                                                    <h5 class="card-title"> Skyscraper</h5>
                                                    <p class="card-text"><img src="/src/assets/img/marketing/skyscraper.jpg" width="100"></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                
                                        <h3>Fiksni formati</h3>
                                        <table class="table">
                                          <thead>
                                              <tr>
                                                  <th>Banner</th>
                                                  <th>Dimenzije (px)</th>
                                                  <th>Dimenzije (px)</th>
                                                  <th>Pozicija</th>
                                                  <th>Cijena (CPM)*</th>
                                              </tr>
                                          </thead>
                                          <tbody>
                                              <tr>
                                                  <td>Fiksni baner 1</td>
                                                  <td>Desktop – 728x90 px</td>
                                                  <td>Mobilna verzija – 320x480 px</td>
                                                  <td>Između vijesti na vrhu stranice</td>
                                                  <td>500</td>
                                              </tr>
                                              <tr>
                                                  <td>Fiksni baner 2</td>
                                                  <td>Desktop – 728x90 px</td>
                                                  <td>Mobilna verzija – 320x480 px</td>
                                                  <td>Između vijesti na sredini stranice</td>
                                                  <td>400</td>
                                              </tr>
                                              <tr>
                                                  <td>Fiksni baner 3</td>
                                                  <td>Desktop – 728x90 px</td>
                                                  <td>Mobilna verzija – 320x480 px</td>
                                                  <td>Između vijesti na dnu stranice</td>
                                                  <td>300</td>
                                              </tr>
                                          </tbody>
                                       </table>
                                        <small>* CPM – cijena po danu</small>
                                        <div class="row u-margin-t-20 u-margin-b-40">
                                            <div class="col-md">
                                                <div class="card">
                                                    <div class="card-body">
                                                        <h5 class="card-title">Desktop</h5>
                                                        <p class="card-text"><img src="/src/assets/img/marketing/desktop.jpg" width="100"></p>
                                                    </div>
                                                    </div>
                                                </div>
                                            <div class="col-md">
                                                <div class="card">
                                                    <div class="card-body">
                                                    <h5 class="card-title"> Mobilna</h5>
                                                    <p class="card-text"><img src="/src/assets/img/marketing/mobile.jpg" width="41"></p>
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                        <h3>PR Tekst</h3>
                                        <p>Promotivni tekst je oglašavanje na na portalu u vidu teksta ili informacije koje prate fotografije i/ili video. Bit će objavljen u sklopu svoje pripadajuće rubrike i zadržat će prvu poziciju 24 sata. </p> 
                                           <table class="table">
                                          <thead>
                                              <tr>
                                                  <th>Format</th>
                                                  <th>Pozicija</th>
                                                  <th>Cijena (KM)</th>
                                              </tr>
                                          </thead>
                                          <tbody>
                                              <tr>
                                                  <td>Promotivni tekst, koji prate fotografija i/ili video *</td>
                                                  <td>Prva vijest u pripadajućoj kategoriji 24 sata</td>
                                                  <td>500</td>
                                              </tr>                 
                                          </tbody>
                                       </table>
                                        <small>*U PR tekstu treba poštivati profesionalne standarde, mora biti istinit, ne smije biti uvredljiv te mora ispunjavati norme dobre poslovne prakse. Usluge novinara i fotografa dodatno se naplaćuju </small>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </div>     
 </template>

<script>
    import { AboutService } from '../common/api.service'
    import Breadcrumb from '../components/Breadcrumb'

    export default {
        name: "Marketing",
        components: { Breadcrumb },
        metaInfo: {
            title: 'Marketing',        
        },
        data() {
            return {
                marketingInfo: {}
            }
        },
        mounted() {
            window.scrollTo(0, 0);
        },
         created() {
            this.fetchData();      
        },
        methods: {
            fetchData: function() {
                AboutService.getMarketingInfo().then(res => this.marketingInfo = res.data);
            }
        }
    }
</script>

<style scoped>
    .marketing-photo img {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 700px;
    }

    .col-sm-2-4 {
        -ms-flex: 0 0 18%;
        flex: 0 0 18%;
        max-width: 18%;

    }
</style>


// WEBPACK FOOTER //
// src/components/Marketing.vue